'use strict';

/**
 * library
 */
import imagesLoaded from 'imagesloaded';
imagesLoaded.makeJQueryPlugin($);
import SimpleBar from 'simplebar';

/**
 * module
 */
import {
    anchor
} from './module/_anchor';
import {
    disabled
} from './module/_disabled';
import {
    fitimg
} from './module/_fitimg';
import {
    hover
} from './module/_hover';
import {
    responsive
} from './module/_responsive';
import {
    nav
} from './module/_nav';
import {
    modal
} from './module/_modal';
import {
    inview
} from './module/_inview';
import {
    header
} from './module/_header';
import {
    justHeight
} from './module/_justHeight';
import {
    toggle
} from './module/_toggle';
import {
    carousel
} from './module/_carousel';
import {
    tabBody
} from './module/_tabBody';
import {
    tab
} from './module/_tab';
import {
    viewport
} from './module/_viewport';
import {
    faq
} from './module/_faq';
import {
    message
} from './module/_message';

/**
 * main
 */
const main = (() => {
    /**
     * loaded
     */
    const loaded = () => {
        setTimeout(() => {
            $('body').addClass('is-loaded');
        }, 100);
    };

    /**
     * isiPhoneXSeries
     */
    const isiPhoneXSeries = () => {
        const isiPhone = /iPhone/.test(window.navigator.userAgent);
        const currentDevicePixel = (window.screen.width * window.screen.height * window.devicePixelRatio);
        const iPhoneXSeriesScreenPixelList = [
            (375 * 812 * 3), // iPhoneX or Xs
            (414 * 896 * 3), // iPhoneXsMax
            (414 * 896 * 2) // iPhoneXR
        ];

        return isiPhone && iPhoneXSeriesScreenPixelList.some((item) => item === currentDevicePixel);
    };

    const isiPad = () => {
        let ua = window.navigator.userAgent.toLowerCase();

        return ua.indexOf('ipad') > 0 || ua.indexOf('macintosh') > 0 && 'ontouchend' in document || ua.indexOf('android') > 0;
    };

    /**
     * init
     */
    const init = () => {
        viewport.init();
        disabled.init();
        fitimg.init();
        hover.init();
        responsive.init();
        nav.init();
        modal.init();
        inview.init();
        header.init();
        justHeight.init();
        toggle.init();
        carousel.init();
        tabBody.init();
        tab.init();
        faq.init();
        anchor.init();
        message.init();

        // if (isiPhoneXSeries()) {
        //     $('body').addClass('is-iPhoneX-series');
        // }

        $('.js-scrBar').each((index, element) => {
            new SimpleBar(element, {
                autoHide: false
            });
        });
    };

    // public
    return {
        init: init,
        loaded: loaded
    };
})();

$(() => {
    main.init();

    $('body')
        .imagesLoaded()
        .done(instance => {
            main.loaded();
        })
        .fail(() => {
            main.loaded();
        });
});